import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/home.vue'
import success from '@/pages/result/success.vue'
import error from '@/pages/result/error.vue'
import loading from '@/pages/load/loading.vue'
import about from '@/pages/home/about'
import product from '@/pages/home/product'
import feedback from '@/pages/home/feedback'
import update from '@/pages/home/update'
import wechat from '@/pages/wechat/wechat'
import wushuang from '@/pages/wechat/wushuang'
import showError from '@/pages/wechat/showError'
import show from '@/pages/show/show'
import noproduct from '@/pages/wechat/noproduct'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'loading'
    },
    {
      path: '/loading',
      name: 'loading',
      component: loading,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/home',
      name: "home",
      component: home,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/success',
      name: 'success',
      component: success,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/error',
      name: 'error',
      component: error,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      meta: {
        title: "真品无双"
      }
    }
    ,
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/update',
      name: 'update',
      component: update,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/wechat',
      name: 'wechat',
      component: wechat,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/wushuang',
      name: 'wushuang',
      component: wushuang,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/showError',
      name: 'showError',
      component: showError,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/show',
      name: 'show',
      component: show,
      meta: {
        title: "真品无双"
      }
    },
    {
      path: '/noproduct',
      name: 'noproduct',
      component: noproduct,
      meta: {
        title: "真品无双"
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js